'use strict';

var QuickFilterDirective = function QuickFilterDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'QuickFilterController',
    template: require('../templates/quick-filter.html'),
    scope: {
      attributes: '=',
      quickFilterData: '=',
      chartAttributes: '='
    }
  };
};
module.exports = QuickFilterDirective;